module.exports = __webpack_public_path__ + "img/success_icon.d5326325.svg";